export const createCheckoutSession = (priceId, userStripeId) => {
  const csrfToken = document.querySelector("[name='csrf-token']").content;
  console.log(csrfToken);
  return fetch("/subscriptions/create_checkout_session_for_plans", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
    },
    body: JSON.stringify({
      priceId: priceId,
      stripe_customer_id: userStripeId,
    }),
  }).then(function (result) {
    return result.json();
  });
};

export const subscribeToPlan = (
  priceId,
  stripePublishableKey,
  userStripeId
) => {
  const stripe = Stripe(stripePublishableKey);
  console.log("here is the stripe instance", stripe);
  console.log(priceId);
  console.log(stripePublishableKey);
  createCheckoutSession(priceId, userStripeId).then(function (data) {
    // Call Stripe.js method to redirect to the new Checkout page
    stripe.redirectToCheckout({
      sessionId: data.sessionId,
    });
    //.then(handleResult);
  });
};
